import { useEffect } from "react";

/**
 * Triggers an action when a specific key or key combination is pressed.
 * @param targetKeyCode The KeyboardEvent.code to listen for (e.g., "KeyD" or "Control+KeyD").
 * @param action The callback action to perform when the key is pressed.
 */
export const useKeyPress = (targetKeyCode: string, cb: () => void) => {
  const downHandler = (e: KeyboardEvent) => {
    if (!e.target) {
      return;
    }

    // If target is a text field, don't do anything
    const target = e.target as HTMLElement;

    if (/^(?:input|textarea)$/i.test(target.tagName)) {
      return;
    }

    if (targetKeyCode.includes("+")) {
      const keys = targetKeyCode.split("+");

      for (const [i, key] of keys.entries()) {
        if (i === keys.length - 1) {
          if (e.code === key) {
            cb();
            break;
          }
        }

        if (!e.getModifierState(key)) {
          break;
        }
      }
    }

    if (e.code === targetKeyCode) {
      cb();
    }
  };

  // Add event listeners
  useEffect(() => {
    window.addEventListener("keydown", downHandler);

    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener("keydown", downHandler);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount
};
